/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Drawer_Inherit_DisabledInputs */



/**
* | output |
* | --- |
* | "Falls back to the everyone value: disabled." |
*
* @param {Rights_Tools_Drawer_Inherit_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_inherit_disabled = /** @type {((inputs?: Rights_Tools_Drawer_Inherit_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_Inherit_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fällt auf den „Alle“-Wert zurück: deaktiviert.")
	return /** @type {LocalizedString} */ ("Falls back to the everyone value: disabled.")
});